import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import LegalNotice from "../../LegalNotice";
import Popup from 'reactjs-popup';


import {
  greeting,
  workExperiences,
  skillsSection,
  openSource,
  blogSection,
  talkSection,
  achievementSection,
  bigProjects
} from "../../portfolio";


function Header() {
  const {isDark} = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewBigProjects = bigProjects.display;
  const viewLegalNotice = bigProjects.display;



  return (
    <Headroom>
        
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/">
        <img  src={require("./logo.png")} alt={"Test"} width="100px" height="50px"  />
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewSkills && (
            <li>
              <a href="#skills">About us</a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a href="#achievements">Research Fields</a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a href="#experience">Services</a>
            </li>
          )}
          {viewBigProjects && (
            <li>
              <a href="#projects">Research Projects</a>
            </li>
          )}
        
          <li>
            <a href="#contact">Contact Us</a>
          </li>
          
{viewLegalNotice && (
  <li>
    <Popup 
      trigger={<a href="#" className="menu-item">Legal Notice</a>}
      modal
      closeOnDocumentClick
      contentStyle={{
        width: "100%",
        height: "100vh",
        border: "none",
        padding: 0
      }}
      overlayStyle={{
        background: "rgba(0,0,0,0.5)"
      }}
    >
      {close => (
        <div style={{
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 20
          }}>
          <button onClick={close} style={{
            position: "absolute",
            top: 20,
            right: 20,
            border: "none",
            background: "none",
            fontSize: "24px",
            cursor: "pointer"
          }}>&times;</button>
          <LegalNotice />
        </div>
      )}
    </Popup>
  </li>
)}
          {/*viewLegalNotice && (
            <li>
              <Popup trigger={<a href="#">Legal Notice</a>} modal closeOnDocumentClick tabletFullscreen className="full-screen-popup">
                <LegalNotice />
              </Popup>
            </li>
          )}
          
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <li>
            <a>
              <ToggleSwitch />
            </a>
            </li>
            <li>
            <a href="https://mat4nrg.de/" className="menu-item">            
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#cc2b1d" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#f8d147"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
            </a>
            </li>
        </ul>
        
      </header>
    </Headroom>
  );
}
export default Header;
